import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import { Text } from "react-internationalization";
import SignaturePad from "react-signature-canvas";
import {
  setStateParams,
  getPcpList,
  deleteFile,
  downloadFormsPdf,
  fetchFileTypes,
} from "../../Redux/Actions/webAppActions";
import { CardioPreEnrollmentForm } from "./Verda/CardioPreEnrollmentForm";
import { VerdaCoordinationForm } from "./Verda/VerdaCoordinationForm";
import { GenericModal } from "../../Utils/GenericUI/Modal/GenericModal";
import { connect } from "react-redux";
import { INITIAL_STATE } from "../initialState";
import Popup from "reactjs-popup";
import AssignPCP from "../AssignPCP";
import RaceCds from "../RaceAndEthicCode/RaceCds";
import EthniCity from "../RaceAndEthicCode/EthniCity";
import TermsAndConditionsContainer from "../TermsAndConditions/TermsAndConditionsContainer";
import AutoComplete1 from "../../Utils/Select";
import {
  NEBRASKA_CONSTS,
  ILS_CONSTS,
  VERDA_CONSTS,
  DataValidation,
} from "../../Utils/StaticData/Constant";
import { FieldLabel, ilsFormats } from "../translations/dynamic";
import { saveAs } from "file-saver";
import PremiumType from "./PremiumTypes/PremiumType";
import { mandatoryFileds } from "../../Utils/StaticData/MandatoryFields";
const defaultPhysician = { label: "---Select---", value: "", officeCode: "" };
const INDICATORS = [
  { label: "Yes", value: "Y" },
  { label: "No", value: "N" },
  { label: "No Answer", value: "NANS" },
];

class Step3 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formerEmpOfSharp: false,
      flag: false,

      pcpShown: this.props.pcpSelected.pcpName
        ? this.props.pcpSelected.pcpName +
          " " +
          "-" +
          " " +
          this.props.pcpSelected.PcpLocationId
        : "",

      clinicShown:
        this.props.pcpSelected.pcpName &&
        this.props.pcpSelected.pcpName !== "---Select---"
          ? this.props.physiciansData.length > 1
            ? this.props.physiciansData.filter(
                (data1) =>
                  // this.props.pendingApplFlag
                  //   ? data1.label === data.pcpName
                  data1.doctorName + " " + "-" + " " + data1?.locationId ===
                  this.props.pcpSelected.pcpName +
                    " " +
                    "-" +
                    " " +
                    this.props.pcpSelected.PcpLocationId
              )[0] != undefined
              ? this.props.physiciansData.filter(
                  (data1) =>
                    // this.props.pendingApplFlag
                    //   ? data1.label === data.pcpName
                    data1.doctorName + " " + "-" + " " + data1?.locationId ===
                    this.props.pcpSelected.pcpName +
                      " " +
                      "-" +
                      " " +
                      this.props.pcpSelected.PcpLocationId
                )[0].clinicName
              : ""
            : ""
          : this.props.preEnrollInfo && this.props.preEnrollInfo.pcpDetails
          ? this.props.preEnrollInfo.pcpDetails.name
          : "",
      stateFlag: false,
      isInitial: true,
      show: false,
      submitted: { cardioVascular: "N", careInd: "N" },
      showCoordination: false,
    };
    this.validator = new SimpleReactValidator();
    this.sigPad = {};
  }
  async componentDidMount() {
    if (
      this.props.data?.pdfBlobs.some(
        (f) => f.attachmentType === "PRE-ENROLLMENT FORM"
      )
    ) {
      this.setState({
        ...this.state,
        submitted: { ...this.state.submitted, cardioVascular: "Y" },
      });
    }
    if (
      this.props.data?.pdfBlobs.some(
        (f) => f.attachmentType === "COORDINATION OF CARE"
      )
    ) {
      this.setState({
        ...this.state,
        submitted: { ...this.state.submitted, careInd: "Y" },
      });
    }
    var fullAddr = this.props.data.permanentAddrStreet
      ? this.props.data.permanentAddrStreet
      : "";

    if (this.props.preEnrollInfo.pcpName) {
      this.setState({
        pcpShown: this.props.preEnrollInfo.pcpName
          ? this.props.preEnrollInfo.pcpName +
            " " +
            "-" +
            " " +
            this.props.preEnrollInfo.locationId
          : "",
        clinicShown: this.props.preEnrollInfo.pcpDetails.name
          ? this.props.preEnrollInfo.pcpDetails.name
          : "",
      });
    }
    if (this.props.data.agentSign !== "" && this.props.agentLogin === false) {
      var canvas = document.getElementById("sigCanvas");
      var context = canvas?.getContext("2d");
      var img = new Image();
      img.src = this.props.data.agentSign;
      img.onload = function () {
        context.drawImage(this, 0, 0);
      };
    }
    const { data, permanentAddrStreet, permanentCity, permanentZip } =
      this.props;
    let zip = data.permanentZip;
    if (
      this.props.product != "PDP" &&
      this.props.productName !== "Medicare Supplement"
    ) {
      if (
        data.permanentAddrStreet !== "" &&
        data.permanentCity !== "" &&
        zip !== "" &&
        this.props.deeplink === false
      ) {
        if (
          data.permanentAddrStreet !== permanentAddrStreet ||
          data.permanentCity !== permanentCity ||
          zip !== permanentZip
        ) {
          this.props.getPcpList({
            address: data.permanentAddrStreet,
            city: data.permanentCity,
            zipCode: zip,
            distance: "100",
            customerId: this.props?.customerId,
            planYear: this?.props?.year,
            productId: this?.props?.product?.toUpperCase(),
          });
          this.props.setStateParams(
            "permanentAddrStreet",
            data.permanentAddrStreet
          );
          this.props.setStateParams("permanentCity", data.permanentCity);
          this.props.setStateParams("permanentZip", zip);
          this.setState({ formerEmpOfSharp: !this.state.formerEmpOfSharp });
        }
      }
      if (
        data.permanentAddrStreet !== "" &&
        data.permanentCity !== "" &&
        this.props.dpzipCode !== "" &&
        this.props.deeplink === true
      ) {
        if (
          data.permanentAddrStreet !== permanentAddrStreet ||
          data.permanentCity !== permanentCity ||
          this.props.dpzipCode !== permanentZip
        ) {
          this.props.getPcpList({
            address: data.permanentAddrStreet,
            city: data.permanentCity,
            zipCode: this.props.dpzipCode,
            distance: "100",
            customerId: this.props?.customerId,
            planYear: this?.props?.year,
            productId: this?.props?.product?.toUpperCase(),
          });
          this.props.setStateParams(
            "permanentAddrStreet",
            data.permanentAddrStreet
          );
          this.props.setStateParams("permanentCity", data.permanentCity);
          this.props.setStateParams("permanentZip", this.props.dpzipCode);
          this.setState({ formerEmpOfSharp: !this.state.formerEmpOfSharp });
        }
      }
      // else {
      if (
        fullAddr === "" ||
        fullAddr === undefined ||
        data.permanentCity === ""
      ) {
        //   if(data.permanentAddrStreet === "" ||
        // data.permanentCity === ""){
        this.setState({ flag: true });
        this.props.setStateParams("physiciansData", []);
        this.props.setSnackBar(
          this.props.language==="en"?"Please fill permanent address in section 1 to get PCP's and Clinic Name.":"Complete la dirección permanente en la sección 1 para obtener el nombre de la clínica y el PCP."
        );
      }
    }
    await this.props.fetchFileTypes();
  }
  async componentDidUpdate(prevProps, prevState, snapShot) {
    const clinicName =
      this.props.pcpSelected.pcpName &&
      this.props.pcpSelected.pcpName !== "---Select---"
        ? this.props.physiciansData.length > 1
          ? this.props.physiciansData.filter(
              (data1) =>
                // this.props.pendingApplFlag
                //   ? data1.label === data.pcpName
                data1.doctorName + " " + "-" + " " + data1?.locationId ===
                this.props.pcpSelected.pcpName +
                  " " +
                  "-" +
                  " " +
                  this.props.pcpSelected.PcpLocationId
            )[0] != undefined
            ? this.props.physiciansData.filter(
                (data1) =>
                  // this.props.pendingApplFlag
                  //   ? data1.label === data.pcpName
                  data1.doctorName + " " + "-" + " " + data1?.locationId ===
                  this.props.pcpSelected.pcpName +
                    " " +
                    "-" +
                    " " +
                    this.props.pcpSelected.PcpLocationId
              )[0].clinicName
            : ""
          : ""
        : this.props.preEnrollInfo && this.props.preEnrollInfo.pcpDetails
        ? this.props.preEnrollInfo.pcpDetails.name
        : "";

    if (
      this.props.pcpSelected.pcpName +
        " " +
        "-" +
        " " +
        this.props.pcpSelected.PcpLocationId !==
      this.state.pcpShown
    ) {
      await this.setState({
        pcpShown: this.props.pcpSelected
          ? this.props.pcpSelected.pcpName +
            " " +
            "-" +
            " " +
            this.props.pcpSelected.PcpLocationId
          : "",
        clinicShown: clinicName,
      });
    }
    if (document.querySelectorAll('[role="dialog"]')[0]) {
      //in modal pop up date pick dropdown is not working so removing tab index
      document
        .querySelectorAll('[role="dialog"]')[0]
        .removeAttribute("tabindex");
    }
  }
  modalClose = () => {
    this.setState({
      ...this.state,
      show: !this.state.show,
    });
    this.props.cardioVascularHandler(this.state.submitted);
    if (this.state.submitted.cardioVascular === "Y") {
      {
        this.props.customerId !== VERDA_CONSTS.ID
          ? this.props.openSnackBar("Submitted Successfully", "success")
          : this.props.openSnackBar("Attached Successfully", "success");
      }
    }
  };
  modalClose1 = () => {
    this.setState({
      ...this.state,
      showCoordination: !this.state.showCoordination,
    });
    this.props.careIndHandler(this.state.submitted);
    if (this.state.submitted.careInd === "Y") {
      {
        this.props.customerId !== VERDA_CONSTS.ID
          ? this.props.openSnackBar("Submitted Successfully", "success")
          : this.props.openSnackBar("Attached Successfully", "success");
      }
    }
  };

  clear = async () => {
    for (let i = 0; i < this.props.data?.attachmentList?.length; i++) {
      if (this.props.data?.attachmentList[i]?.attachmentType === "SIGNATURE") {
        const appNumber = this.props.pendingApplFlag
          ? // authenticatedData.pendingAppNum
            this.props?.appNum
          : this.props.guestbeneagentAppNum
          ? this.props.guestbeneagentAppNum
          : this.props.count
          ? this.props.count
          : null;
        await this.props.deleteFile({
          appNumber: appNumber,
          attachmentId: this.props.data?.attachmentList[i]?.attachmentId,
          attachmentName: this.props.data?.attachmentList[i]?.attachmentName,
          customerId: this.props?.customerId,
        });
      }
    }
    if (this.props.pendingApplFlag === true) {
      this.props.filterDeletedSignature();
    }
    this.sigPad.clear();
    this.props.clear();
    document.getElementById("sigImg").replaceChildren();
  };
  isSubmitted = (data) => {
    this.setState({
      ...this.state,
      submitted: { ...this.state.submitted, ...data },
    });
  };
  setFlag = () => {
    this.setState({
      stateFlag: true,
    });
  };
  save = () => {
    this.props.saveSign(
      this.sigPad.getTrimmedCanvas().toDataURL("image/png"),
      true
    );

    let canvasEle = this.sigPad.getTrimmedCanvas();
    let image = new Image();
    image.src = canvasEle.toDataURL();
    document.getElementById("sigImg").replaceChildren();
    document.getElementById("sigImg").appendChild(image);
  };
  downloadPdf = async (e) => {
    let pdf = this.props.data.pdfBlobs.filter(
      (b) => b.attachmentType === e.target.id
    )[0].attachment;
    if (pdf !== null) {
      saveAs(pdf, `${e.target.id}`);
    } else {
      //this.props.openSnackBar("Cannot download the file","error")
      let attachmentType;
      let pdfname = `${e.target.id}` + ".pdf";
      if (`${e.target.id}` === "COORDINATION OF CARE") {
        attachmentType = "CC";
      } else {
        attachmentType = "PEP";
      }
      const payload = {
        appNumber: this?.props?.appNum,
        customerId: this?.props?.customerId,
        attachmentType: attachmentType,
      };
      const response = await this?.props.downloadFormsPdf(payload);
      if (response.status === "OK") {
        const blob = "data:application/pdf;base64," + response.data;
        saveAs(blob, pdfname);
      }
    }
  };
  render() {
    const { data } = this.props;
    let pcpDropdownList = [];
    let removeKeys = ["---Select---"];
    let filteredphysiciansData = this?.props?.physiciansData.filter(
      (obj) => removeKeys.indexOf(obj.label) === -1
    );
    if (this.props.customerId === NEBRASKA_CONSTS.ID) {
      filteredphysiciansData.forEach((element) =>
        pcpDropdownList.push({
          label: element?.label ? element?.label : element?.doctorName,
          value: element.doctorName
            ? element.doctorName + " " + "-" + " " + element?.locationId
            : "",
        })
      );
    } else {
      filteredphysiciansData.forEach((element) =>
        pcpDropdownList.push({
          label: element?.label
            ? element?.label +
              " " +
              "-" +
              " " +
              element?.locationId?.trim() +
              " " +
              "-" +
              " " +
              element?.doctorAddress
            : element?.doctorName +
              " " +
              "-" +
              " " +
              element?.locationId?.trim() +
              " " +
              "-" +
              " " +
              element?.doctorAddress,
          value: element.doctorName
            ? element.doctorName + " " + "-" + " " + element?.locationId
            : "",
        })
      );
    }
    let pcpVal =
      this.state.pcpShown != "" &&
      this.state.pcpShown != "undefined - undefined"
        ? this.state.pcpShown
        : this.props.preEnrollInfo.pcpName
        ? this.props.preEnrollInfo.pcpName +
          " " +
          "-" +
          " " +
          this.props.preEnrollInfo.locationId
        : ""
        ? this.props.preEnrollInfo.pcpName
          ? this.props.preEnrollInfo.pcpName +
            " " +
            "-" +
            " " +
            this.props.preEnrollInfo.locationId
          : ""
        : "";
    // }

    return (
      <React.Fragment>
        <GenericModal
          show={this.state.show}
          modalClose={this.modalClose}
          form={
            <CardioPreEnrollmentForm
              data={this.props.data}
              cancel={this.modalClose}
              savePdfBlobs={this.props.savePdfBlobs}
              isSubmitted={this.isSubmitted}
              closeModal={this.modalClose}
            />
          }
          size="xl"
          cls="modal-width"
        />
        <GenericModal
          show={this.state.showCoordination}
          modalClose={this.modalClose1}
          form={
            <VerdaCoordinationForm
              data={this.props.data}
              PcpLocationId={this.props.PcpLocationId}
              pcpName={this.props.pcpName}
              cancel={this.modalClose1}
              savePdfBlobs={this.props.savePdfBlobs}
              isSubmitted={this.isSubmitted}
              closeModal={this.modalClose1}
            />
          }
          size="xl"
          cls="modal-width"
        />
        <div
          class={
            data?.appStatus === "READY" || data?.appStatus === "SUBMITTED"
              ? "tab-content tab-contentSharp disable-form"
              : "tab-content tab-contentSharp"
          }
        >
          <div id="step1" class="container-Cambia tab-pane active">
            <h3 class="tab-heading">
              <Text id="step2.Step2" /> –{" "}
              <Text
                id={this.props.agentLoggedIn ? "step2.subStep" : "app.stepSub"}
              />
            </h3>
            <div class="form-panel">
              <p>
                <strong>
                  A. <Text id="step2.A" />.
                </strong>
              </p>
              <p>
                <strong>
                  <Text id="app.racePara" />
                </strong>
              </p>
              <div class="form-group">
                <RaceCds
                  handleRaceAndEthic={this.props.handleRaceAndEthic}
                  ethnicityRace={this.props.data.ethnicityRace}
                />
              </div>
              <p>
                <strong>
                  <Text id="step2.Quest23" />
                </strong>
              </p>
              <div class="form-group">
                <EthniCity
                  handleRaceAndEthic={this.props.handleRaceAndEthic}
                  ethnicityRace={this.props.data.ethnicityRace}
                />
              </div>
              <div class="form-group">
                {/* Below is for all customers except verda,nebraska & ils. it is the default vanilla UI
                  if any customer needs any extra implement the way as implemented for ILS below.
                */}
                {[VERDA_CONSTS.ID, NEBRASKA_CONSTS.ID, ILS_CONSTS.ID].every(
                  (c) => c !== this.props.customerId
                ) && (
                  <div class="display-inline-flex">
                    <label for="language" class="control-label mr-2">
                      <Text id="step2.A1" />.
                    </label>
                    <div class="m-top-0 m-left-2em custom-control1 custom-checkbox">
                      <input
                        type="checkbox"
                        name="prefLng"
                        id="language"
                        class="custom-control-input"
                        value="SPA"
                        onChange={this.props.handleChange}
                        checked={this.props.data?.prefLng === "SPA"}
                      />
                      <label
                        for="language"
                        class="radio-inline custom-control-label"
                      >
                        <Text id="step2.Spanish" />
                      </label>
                    </div>
                  </div>
                )}
                {/* Below accessible formats contains code for ILS only*/}
                {ILS_CONSTS.ID === this.props.customerId && (
                  <fieldset class="radio radio-tab mt-3">
                    <legend>
                      <Text id="step2.A1" />.
                    </legend>
                    {ilsFormats(this.props.language).map((ilsF, ilsId) => (
                      <div class="custom-control custom-radio custom-control-inline mt-1">
                        <input
                          type="radio"
                          name="prefLng"
                          id={ilsF?.id}
                          className="custom-control-input"
                          value={ilsF.value}
                          checked={data?.prefLng === ilsF?.value}
                          onClick={this.props.handleChange}
                          onChange={this.props.handleChange}
                        />
                        <label
                          htmlFor={ilsF?.id}
                          class="radio-inline custom-control-label"
                        >
                          {ilsF?.label.charAt(0) +
                            ilsF?.label.substring(1)?.toLowerCase()}
                        </label>
                      </div>
                    ))}
                     {data?.prefLng === "OTH"
                    && (
                      <div class="custom-control custom-radio custom-control-inline mt-1 pl-0">
                        <input
                          type="text"
                          id="prefLngOthrValue"
                          name="prefLngOthrValue"
                          value={data?.prefLngOthrValue}
                          onChange={(event) => {
                            if (
                              event.target.value !== "" &&
                              !DataValidation.test(event.target.value)
                            ) {
                              return;
                            }
                            this.props.handleChange(event);
                          }}
                          class={"form-control custom-control-inline mt-1"}
                          autoComplete="off"
                          // style={{ border: "1px solid #999" }}
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                        />
                      </div>
                    )
                    }
                  </fieldset>
                )}
                {/* Below accessible formats contains code for all customers except NEBRASKA, */}
                {[NEBRASKA_CONSTS.ID].every(
                  (c) => c !== this.props.customerId
                ) && (
                  <fieldset class="radio radio-tab mt-3">
                    <legend>
                      <Text id="step2.A2" />.
                    </legend>
                    <div class="custom-control custom-radio custom-control-inline mt-1">
                      <input
                        type="radio"
                        name="accessibleFormatVal"
                        id="lfp_braille"
                        class="custom-control-input"
                        value="B"
                        checked={data.accessibleFormatVal === "B"}
                        onClick={this.props.handleChange}
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="lfp_braille"
                        class="radio-inline custom-control-label"
                      >
                        <Text id="step2.Ar1" />
                      </label>
                    </div>
                    {[VERDA_CONSTS.ID, ILS_CONSTS.ID].some(
                      (k) => k === this.props.customerId
                    ) ? (
                      <>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="accessibleFormatVal"
                            id="lfp_largeprint"
                            class="custom-control-input"
                            value="L"
                            checked={data.accessibleFormatVal === "L"}
                            onClick={this.props.handleChange}
                            onChange={this.props.handleChange}
                          />
                          <label
                            for="lfp_largeprint"
                            class="radio-inline custom-control-label"
                          >
                            {/* <Text id="verda.step3.Ar2" /> */}
                            <Text id="step2.Ar2" />
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline mt-1 other-radio-mobile-aligner">
                          <input
                            type="radio"
                            name="accessibleFormatVal"
                            id="lfp_other"
                            class="custom-control-input"
                            value="A"
                            checked={data.accessibleFormatVal === "A"}
                            onClick={this.props.handleChange}
                            onChange={this.props.handleChange}
                          />
                          <label
                            for="lfp_other"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="verda.step3.Ar3" />
                          </label>
                        </div>
                      </>
                    ) : (
                      <>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="accessibleFormatVal"
                            id="lfp_largeprint"
                            class="custom-control-input"
                            value="L"
                            checked={data.accessibleFormatVal === "L"}
                            onClick={this.props.handleChange}
                            onChange={this.props.handleChange}
                          />
                          <label
                            for="lfp_largeprint"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="step2.Ar2" />
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline mt-1 other-radio-mobile-aligner">
                          <input
                            type="radio"
                            name="accessibleFormatVal"
                            id="lfp_other"
                            class="custom-control-input"
                            value="OTHER"
                            checked={data.accessibleFormatVal === "OTHER"}
                            onClick={this.props.handleChange}
                            onChange={this.props.handleChange}
                          />
                          <label
                            for="lfp_other"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="step2.Ar3" />
                          </label>
                        </div>
                      </>
                    )}
                    {/* <div
                    class="custom-control custom-control-inline mt-1 w-70"

                  >
                    <input
                      type="text"
                      id="otherlanguageValue"
                      name="accessibleFormatOthersVal"
                      value={
                        data.accessibleFormatVal === "BRAILLE" ||
                          data.accessibleFormatVal === "LARGEPRINT" ||
                          data.accessibleFormatVal === ""
                          ? ""
                          : data.accessibleFormatOthersVal
                      }
                      disabled={
                        data.accessibleFormatVal === "" ||
                        data.accessibleFormatVal === "BRAILLE" ||
                        data.accessibleFormatVal === "LARGEPRINT"
                      }
                      onChange={this.props.handleChange}
                      class={"form-control"}
                    />
                  </div> */}
                  </fieldset>
                )}

                <br />
                <p class="medicare-note">
                  {FieldLabel("accessibleNote", this.props.customerId)}
                </p>
              </div>
              <div class="form-group">
                {this.props.productName !== "Medicare Supplement" ? (
                  <>
                    {this.props.product != "PDP" ? (
                      <p>
                        <strong>
                          B. <Text id="step2.B" />
                          {this.props.planType === "HMO" ? "*" : ""}
                        </strong>
                      </p>
                    ) : null}
                    {this.props.product != "PDP" ? (
                      <div class="row mt-3">
                        <div class="col-md-6">
                          {this.props.pcpSubscription !== "Y" ? (
                            <>
                              <label for="pcpName" class="control-label">
                                <Text id="step2.PCPName" />
                                {this.props.planType === "HMO" ? "*" : ""}
                              </label>
                              <br />
                              <AutoComplete1
                                field="pcpName"
                                // dashboard="prospect"
                                error={
                                  this.props.planType === "HMO" &&
                                  (pcpVal === "" ||
                                    pcpVal === "undefined - undefined" ||
                                    pcpVal === "  -  ")
                                }
                                handleChange={this.props.handleDropdown(
                                  "pcpName"
                                )}
                                options={pcpDropdownList}
                                value={
                                  pcpDropdownList?.filter(
                                    (data1) => data1?.value === pcpVal
                                  ).length !== 0
                                    ? pcpDropdownList?.filter(
                                        (data1) => data1?.value === pcpVal
                                      )[0]
                                    : {
                                        label: "select",
                                        value: "",
                                      }
                                }
                                defaultValue={{ label: "select", value: "" }}
                                name="pcpName"
                              />
                            </>
                          ) : (
                            <>
                              <label for="pcpName" class="control-label">
                                <Text id="step2.PCPName" />
                                {this.props.planType === "HMO" ? "*" : ""}
                                <div class="pcp-step3">
                                  <p>
                                    {this.state.pcpShown &&
                                    this.state.pcpShown != "" &&
                                    this.state.pcpShown !=
                                      "undefined - undefined"
                                      ? ": " + " " + this.state.pcpShown
                                      : this.props.preEnrollInfo.pcpName
                                      ? ": " +
                                        " " +
                                        this.props.preEnrollInfo.pcpName
                                      : ""}
                                  </p>
                                </div>
                              </label>
                              <div class="m-top-neg15">
                                <Popup
                                  className={"pcp-popup"}
                                  modal
                                  trigger={
                                    <button class="assign-pcp" id="pcp_popup">
                                      <Text id="step4Agent.assignpcp" />
                                    </button>
                                  }
                                  position="right center"
                                  repositionOnResize={true}
                                  contentStyle={{
                                    width: "77% !important",
                                    padding: "0px",
                                  }}
                                >
                                  {(close) => (
                                    <div>
                                      <AssignPCP
                                        data={this.props.data}
                                        setFlag={this.setFlag}
                                        flag={this.state.stateFlag}
                                        close={close}
                                        pcpList={this.props.physiciansData.slice(
                                          1
                                        )}
                                        preSelectedPCP={this.props.pcpSelected}
                                        preEnrollInfo={
                                          this.props.preEnrollInfo
                                            ? this.props.preEnrollInfo
                                            : ""
                                        }
                                        stateId={this.props.stateId}
                                        makePcpEmpty={this.props.makePcpEmpty}
                                      />
                                    </div>
                                  )}
                                </Popup>
                              </div>
                            </>
                          )}
                        </div>
                        <div class="col-md-6 assign-pcp-margin">
                          <label
                            for="pcpMedicalGroupName"
                            class="control-label"
                          >
                            <Text id="step2.ClinicName" />
                            {this.props.planType === "HMO" ? "*" : ""}
                            {/* :* */}
                          </label>

                          <input
                            type="text"
                            id="pcpMedicalGroupName"
                            name="pcpMedicalGroupName"
                            value={
                              this.state.clinicShown
                                ? this.state.clinicShown
                                : this.props.pcpSelected.pcpName &&
                                  this.props.pcpSelected.pcpName !==
                                    "---Select---"
                                ? this.props.physiciansData.length > 1
                                  ? this.props.physiciansData.filter(
                                      (data1) =>
                                        // this.props.pendingApplFlag
                                        //   ? data1.label === data.pcpName
                                        data1.doctorName ===
                                        this.props.pcpSelected.pcpName
                                    )[0] != undefined
                                    ? this.props.physiciansData.filter(
                                        (data1) =>
                                          data1.doctorName ===
                                          this.props.pcpSelected.pcpName
                                      )[0].clinicName
                                    : ""
                                  : ""
                                : ""
                            }
                            onChange={this.props.handleChange}
                            disabled="true"
                            class={
                              this.props.customerId===ILS_CONSTS.ID
                              ? (pcpVal === "" ||
                                pcpVal === "undefined - undefined" || //currently for ILS grup name is empty for all pcp
                                pcpVal === "  -  ") && this.props?.planType === "HMO"
                                  ?"error-input cursor-not-allowed"
                                  :"form-control cursor-not-allowed"
                              :this.props?.planType === "HMO"
                                ? this.state?.clinicShown != "" &&
                                  this.state?.clinicShown != undefined
                                  ? "form-control cursor-not-allowed"
                                  : "error-input cursor-not-allowed"
                                : "form-control cursor-not-allowed"
                            }
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                          />
                        </div>
                      </div>
                    ) : null}
                    <div class="row mt-3">
                      <div class="col-md-4">
                        <fieldset class="radio radio-tab mt-3">
                          <legend>
                            <Text id="step2.currentpatient" />
                          </legend>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input
                              type="radio"
                              name="isCurrentPatient"
                              id="currentPatient_Y"
                              class="custom-control-input"
                              value="Y"
                              checked={data.isCurrentPatient === "Y"}
                              onChange={this.props.handleChange}
                            />
                            <label
                              for="currentPatient_Y"
                              class="radio-inline custom-control-label"
                            >
                              <Text id="app.Yes" />
                            </label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input
                              type="radio"
                              name="isCurrentPatient"
                              id="currentPatient_no"
                              class="custom-control-input"
                              value="N"
                              checked={data.isCurrentPatient === "N"}
                              onChange={this.props.handleChange}
                            />
                            <label
                              for="currentPatient_no"
                              class="radio-inline custom-control-label"
                            >
                              No
                            </label>
                          </div>
                        </fieldset>
                      </div>
                      <div class="col-md-4">
                        <fieldset class="radio radio-tab mt-3">
                          <legend>
                            <Text id="step2.Dowork" />
                          </legend>
                          <div class="custom-control custom-radio custom-control-inline mt-1">
                            <input
                              type="radio"
                              name="doYouWork"
                              id="dDoYouWork_Yes"
                              class="custom-control-input"
                              value="Y"
                              checked={data.doYouWork === "Y"}
                              onChange={this.props.handleChange}
                            />
                            <label
                              for="dDoYouWork_Yes"
                              class="radio-inline custom-control-label"
                            >
                              <Text id="app.Yes" />
                            </label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline mt-1">
                            <input
                              type="radio"
                              name="doYouWork"
                              id="dDoYouWork_No"
                              class="custom-control-input"
                              value="N"
                              checked={data.doYouWork === "N"}
                              onChange={this.props.handleChange}
                            />
                            <label
                              for="dDoYouWork_No"
                              class="radio-inline custom-control-label"
                            >
                              No
                            </label>
                          </div>
                        </fieldset>
                      </div>
                      <div class="col-md-4">
                        <fieldset class="radio radio-tab mt-3">
                          <legend>
                            <Text id="step2.spousework" />
                          </legend>
                          <div class="custom-control custom-radio custom-control-inline mt-1">
                            <input
                              type="radio"
                              name="isSpouseWork"
                              id="dDoYourSpouseWork_Yes"
                              class="custom-control-input"
                              value="Y"
                              checked={data.isSpouseWork === "Y"}
                              onChange={this.props.handleChange}
                            />
                            <label
                              for="dDoYourSpouseWork_Yes"
                              class="radio-inline custom-control-label"
                            >
                              <Text id="app.Yes" />
                            </label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline mt-1">
                            <input
                              type="radio"
                              name="isSpouseWork"
                              id="dDoYourSpouseWork_No"
                              class="custom-control-input"
                              value="N"
                              checked={data.isSpouseWork === "N"}
                              onChange={this.props.handleChange}
                            />
                            <label
                              for="dDoYourSpouseWork_No"
                              class="radio-inline custom-control-label"
                            >
                              No
                            </label>
                          </div>
                        </fieldset>
                      </div>
                      <div class="form-group">
                        <div class="col-md-12">
                          <fieldset class="radio radio-tab mt-3">
                            <legend>
                              <Text id="step2.smp" />
                              {this.props.productId?.includes("DSN") && [ILS_CONSTS.ID].some((ids)=>ids===this.props.customerId)
                              ?<strong className="mandatory-field-bold">*</strong>
                              :null}
                            </legend>
                            <div class="custom-control custom-radio custom-control-inline mt-1">
                              <input
                                type="radio"
                                name="medicaidInd"
                                id="isSMP_Yes"
                                class="custom-control-input"
                                value="Y"
                                checked={data.medicaidInd === "Y"}
                                onChange={this.props.handleChange}
                              />
                              <label
                                for="isSMP_Yes"
                                class="radio-inline custom-control-label"
                              >
                                <Text id="app.Yes" />
                              </label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline mt-1">
                              <input
                                type="radio"
                                name="medicaidInd"
                                id="isSMP_No"
                                class="custom-control-input"
                                value="N"
                                checked={data.medicaidInd === "N"}
                                onChange={this.props.handleChange}
                              />
                              <label
                                for="isSMP_No"
                                class="radio-inline custom-control-label"
                              >
                                No
                              </label>
                            </div>
                          </fieldset>
                        </div>
                        {data.medicaidInd === "Y" ? (
                          <div class="col-md-12">
                            <div class="custom-control-inline mt-3">
                              <label class="control-label" for="medicaidInd">
                               <Text id="step3.medicaidnumber" />:* &nbsp;
                              </label>
                              <span>
                                <input
                                  type="text"
                                  name="medicaidId"
                                  id="medicaidId"
                                  required=""
                                  class={
                                    this.props.data.medicaidId === ""
                                      ? "error-input"
                                      : "form-control"
                                  }
                                  maxLength="20"
                                  onChange={this.props.handleChange}
                                  value={data.medicaidId}
                                  autoComplete="off"
                                  spellcheck="false"
                                  aria-autocomplete="both"
                                  aria-haspopup="false"
                                />
                              </span>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      {/* {this.props.agentLoggedIn &&  */}
                      {this.props.customerId !== VERDA_CONSTS.ID &&
                        this.props.ltcList?.length > 1 && (
                          <div class="col-md-12 mb-2">
                            <fieldset class="radio radio-tab mt-3">
                              <legend>
                                <Text id="step2.ltc" />
                              </legend>
                              <div class="custom-control custom-radio custom-control-inline mt-1">
                                <input
                                  type="radio"
                                  name="ltcInd"
                                  id="isLTC_Yes"
                                  class="custom-control-input"
                                  value="Y"
                                  checked={data.ltcInd === "Y"}
                                  onChange={this.props.handleChange}
                                />
                                <label
                                  for="isLTC_Yes"
                                  class="radio-inline custom-control-label"
                                >
                                  <Text id="app.Yes" />
                                </label>
                              </div>
                              <div class="custom-control custom-radio custom-control-inline mt-1">
                                <input
                                  type="radio"
                                  name="ltcInd"
                                  id="isLTC_No"
                                  class="custom-control-input"
                                  value="N"
                                  checked={data.ltcInd === "N"}
                                  onChange={this.props.handleChange}
                                />
                                <label
                                  for="isLTC_No"
                                  class="radio-inline custom-control-label"
                                >
                                  <Text id="app.No" />
                                </label>
                              </div>
                            </fieldset>
                          </div>
                        )}
                      {/* } */}
                      {data.ltcInd === "Y" ? (
                        <div class="row ml-3">
                          <div class="col-md-9">
                            {/* <div class="custom-control-inline mt-3"> */}
                            <label
                              class="control-label"
                              for="nameOfInstitution"
                            >
                              <Text id="st2cat3.isnt" />
                              :* &nbsp;
                            </label>
                            {/* hi */}
                            <select
                              name="nameOfInstitution"
                              id="nameOfInstitution"
                              class={
                                this.props.data.nameOfInstitution === "" ||
                                this.props.data?.nameOfInstitution ===
                                  "---SELECT---"
                                  ? "error-input"
                                  : "form-control"
                              }
                              onChange={this.props.handleChange}
                              value={data.nameOfInstitution}
                            >
                              {this.props.ltcList.map((item, i) => {
                                return (
                                  <option
                                    class="select-option"
                                    value={item.label?.trim()}
                                    key={i}
                                  >
                                    {item.label}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div class="col-md-9">
                            {/* <div class="custom-control-inline mt-3"> */}
                            <label
                              class="control-label"
                              for="addrOfInstitution"
                            >
                              <Text id="st2cat3.adressint" />
                              :* &nbsp;
                            </label>
                            <span>
                              <input
                                type="text"
                                name="addrOfInstitution"
                                id="addrOfInstitution"
                                required=""
                                class={
                                  this.props.data.addrOfInstitution === ""
                                    ? "error-input"
                                    : "form-control"
                                }
                                maxLength="50"
                                disabled
                                onChange={this.props.handleChange}
                                // value={data.addrOfInstitution}
                                value={
                                  this.props.ltcList &&
                                  this.props.ltcList?.filter((address) =>
                                    address.label.includes(
                                      data.nameOfInstitution
                                    )
                                  )[0] != undefined
                                    ? this.props.ltcList?.filter((address) =>
                                        address.label.includes(
                                          data.nameOfInstitution
                                        )
                                      )[0].value
                                    : ""
                                }
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                              />
                            </span>
                            {/* </div> */}
                          </div>
                        </div>
                      ) : null}
                      {this.props.customerId === VERDA_CONSTS.ID && (
                        <>
                          {(this.props.productId === "TX2B" ||
                            this.props.data?.productId === "TX2B") && (
                            <div class="col-md-12 mb-2">
                              <fieldset
                                class="radio radio-tab mt-3"
                                id="cardioVascular_radio"
                              >
                                <legend>
                                  <Text id="verda.cardioVascular" />
                                  <strong className="mandatory-field-bold">
                                    *
                                  </strong>
                                </legend>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <input
                                    type="radio"
                                    name="cardioVascular"
                                    id="cardioVascular_Y"
                                    class="custom-control-input"
                                    value="Y"
                                    onChange={(e) => {
                                      this.props.handleChange(e);
                                      let flag = this.props.data.pdfBlobs.some(
                                        (f) =>
                                          f.attachmentType ===
                                          "PRE-ENROLLMENT FORM"
                                      );
                                      this.setState({
                                        ...this.state,
                                        show: !flag,
                                      });
                                    }}
                                    onClick={(e) => {
                                      this.props.handleChange(e);
                                      let flag = this.props.data.pdfBlobs.some(
                                        (f) =>
                                          f.attachmentType ===
                                          "PRE-ENROLLMENT FORM"
                                      );
                                      this.setState({
                                        ...this.state,
                                        show: !flag,
                                      });
                                    }}
                                    checked={
                                      data.cardioVascular === "Y" ? true : false
                                    }
                                  />
                                  <label
                                    for="cardioVascular_Y"
                                    class="radio-inline custom-control-label"
                                  >
                                    <Text id="app.Yes" />
                                  </label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <input
                                    type="radio"
                                    name="cardioVascular"
                                    id="cardioVascular_no"
                                    class="custom-control-input"
                                    value="N"
                                    onChange={(e) => {
                                      this.props.handleChange(e);
                                      this.setState({
                                        ...this.state,
                                        show: false,
                                      });
                                    }}
                                    onClick={(e) => {
                                      this.props.handleChange(e);
                                      this.setState({
                                        ...this.state,
                                        show: false,
                                      });
                                    }}
                                    checked={
                                      data.cardioVascular === "N" ? true : false
                                    }
                                    disabled
                                  />
                                  <label
                                    for="cardioVascular_no"
                                    class="radio-inline custom-control-label"
                                  >
                                    No
                                  </label>
                                </div>
                              </fieldset>
                            </div>
                          )}
                          <div class="col-md-12 mb-2">
                            <fieldset class="radio radio-tab mt-3">
                              <legend>
                                <Text id="verda.step3.care" />
                                {this.props.customerId === VERDA_CONSTS.ID && (
                                  <strong className="mandatory-field-bold">
                                    *
                                  </strong>
                                )}
                              </legend>
                              <div class="custom-control custom-radio custom-control-inline mt-1">
                                <input
                                  type="radio"
                                  name="careInd"
                                  id="care_Yes"
                                  class="custom-control-input"
                                  value="Y"
                                  checked={data.careInd === "Y"}
                                  // onChange={this.props.handleChange}
                                  onChange={(e) => {
                                    this.props.handleChange(e);
                                    let flag = this.props.data.pdfBlobs.some(
                                      (f) =>
                                        f.attachmentType ===
                                        "COORDINATION OF CARE"
                                    );
                                    this.setState({
                                      ...this.state,
                                      showCoordination: !flag,
                                    });
                                  }}
                                  onClick={(e) => {
                                    this.props.handleChange(e);
                                    let flag = this.props.data.pdfBlobs.some(
                                      (f) =>
                                        f.attachmentType ===
                                        "COORDINATION OF CARE"
                                    );
                                    this.setState({
                                      ...this.state,
                                      showCoordination: !flag,
                                    });
                                  }}
                                />
                                <label
                                  for="care_Yes"
                                  class="radio-inline custom-control-label"
                                  showCoordination
                                >
                                  <Text id="app.Yes" />
                                </label>
                              </div>
                              <div class="custom-control custom-radio custom-control-inline mt-1">
                                <input
                                  type="radio"
                                  name="careInd"
                                  id="care_no"
                                  class="custom-control-input"
                                  value="N"
                                  checked={data.careInd === "N"}
                                  //onChange={this.props.handleChange}
                                  onChange={(e) => {
                                    this.props.handleChange(e);
                                    this.setState({
                                      ...this.state,
                                      showCoordination: false,
                                    });
                                  }}
                                  onClick={(e) => {
                                    this.props.handleChange(e);
                                    this.setState({
                                      ...this.state,
                                      showCoordination: false,
                                    });
                                  }}
                                  // disabled={this.props.data.pdfBlobs.some((f)=>f.attachmentType==="COORDINATION OF CARE")}
                                  disabled
                                />
                                <label
                                  for="care_no"
                                  class="radio-inline custom-control-label"
                                >
                                  No
                                </label>
                              </div>
                            </fieldset>
                          </div>
                          {this.props.data?.pdfBlobs?.length > 0 && (
                            <div class="col-md-12 mb-2">
                              <label for="nameSignature" class="control-label">
                                Attached Documents
                              </label>
                              <div>
                                {this.props.data.pdfBlobs.map((f) => (
                                  <div class="mr-3" key={f.attachmentType}>
                                    <a
                                      class="anchrhiglighted"
                                      id={f.attachmentType}
                                      onClick={(e) => this.downloadPdf(e)}
                                    >
                                      {f.attachmentType}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </>
                      )}
                      {/* newfields */}
                    </div>
                  </>
                ) : null}

                <div class="row mt-3">
                  <div class="col-md-12">
                    <label for="clinicName" class="control-label">
                      <Text id="step2.Email" />:
                    </label>
                    <input
                      type="text"
                      id="emailAddress"
                      name="emailAddress"
                      value={data.emailAddress}
                      maxLength="50"
                      onChange={this.props.handleChange}
                      class={
                        data.emailOptionIndicator === "Y"
                          ? data.emailAddress === "" ||
                            this.validator.check(data.emailAddress, "email") ===
                              false
                            ? "error-input"
                            : "form-control"
                          : "form-control"
                      }
                      onBlur={this.props.OnBlurEmailAddr}
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                    {/* {this.props.customerId===VERDA_CONSTS.ID &&  */}
                    <div class="checkbox checkbox-tab mt-1">
                      {this.props.customerId===ILS_CONSTS.ID &&
                        <div class="custom-control custom-checkbox custom-control-inline mr-1 pl-0">
                          <span><Text id="ils.step3.emailText1"/></span>
                        </div>
                      }
                      <div class="custom-control custom-checkbox custom-control-inline ml-0">
                        <input
                          type="checkbox"
                          checked={
                            data.emailOptionIndicator === "Y" ? true : false
                          }
                          id="emailAlert"
                          name="emailOptionIndicator"
                          class="custom-control-input"
                          onChange={this.props.handleChange}
                        />
                        <label for="emailAlert" class="custom-control-label">
                          {FieldLabel("emailOptionIndicator",this.props.customerId)}
                        </label>
                      </div>
                      {this.props.customerId===ILS_CONSTS.ID &&
                       <div class="custom-control custom-checkbox custom-control-inline ml-1">
                       <input
                         type="checkbox"
                         checked={
                           data?.textIndicator === "Y" ? true : false
                         }
                         id="textIndicator"
                         name="textIndicator"
                         class="custom-control-input"
                         onChange={this.props.handleChange}
                         value="Y"
                       />
                       <label for="textIndicator" class="custom-control-label">
                         <Text id="ils.step3.textIndicator" />
                       </label>
                     </div>
                      }
                    </div>
                  </div>
                  {this.props.agentLogin === false && (
                    <div class="mt-3 col-md-12">
                      <label class="control-label" for="fileUpload">
                        <Text id="step4Agent.fileUpload" />
                      </label>
                      <div class="card">
                        <div className="card-header file-upload-container-aligner display-inline-flex">
                          <div class="file-step3">
                            <label
                              class="control-label m-bottom-0"
                              for="fileType"
                            >
                              Select File Type
                            </label>
                            <select
                              name="fileType"
                              id="fileType"
                              class={"form-control"}
                              value={this.props.fileType}
                              onChange={this.props.handleChange}
                            >
                              <>
                                <option class="select-option" value={""}>
                                  Select
                                </option>
                                {this.props.typeOfFilesToUpload.map(
                                  (item, i) => {
                                    return (
                                      <option
                                        class="select-option"
                                        value={item.attachmentType}
                                        key={i}
                                      >
                                        {item.attachmentDesc}
                                      </option>
                                    );
                                  }
                                )}
                              </>
                            </select>
                          </div>
                          <div className="file-upload-aligner file-upload">
                            <label
                              className={
                                this.props.fileType === ""
                                  ? "btn btn-secondary"
                                  : "btn btn-primary"
                              }
                            >
                              <input
                                type="file"
                                name="fileUpload"
                                class="display-none"
                                id="fileUpload1"
                                onChange={(e) => this.props.handleChange(e)}
                                onClick={(event) => (event.target.value = "")}
                                disabled={
                                  this.props.fileType === "" ? true : false
                                }
                              />
                              <i
                                className="fa fa-upload"
                                aria-hidden="true"
                              ></i>
                              &nbsp;
                              <Text id="step4Agent.uploadFile" />
                            </label>
                          </div>
                        </div>
                        <div class="panel">
                          <div class="card-body">
                            {this.props.selectedFiles.map(
                              (file, index) =>
                                // {file.attachmentType!=="SIGNATURE" ?
                                file.attachmentType !== "SIGNATURE" &&
                                file.attachmentType !== "ENROLLMENT" &&
                                file.attachmentType !== "SOA" && (
                                  <div class="row" key={index}>
                                    <p class="col-md-3">
                                      {file?.name || file?.attachmentType}
                                    </p>
                                    <a
                                      href={this.props.url}
                                      target="_blank"
                                      class="col-md-5 anchrhiglighted"
                                      onClick={(e) =>
                                        this.props.viewFile(
                                          index,
                                          file?.name || file?.attachmentName,
                                          e
                                        )
                                      }
                                    >
                                      {file?.File?.name || file?.attachmentName}
                                    </a>
                                    <p class="col-md-2">
                                      {file && file.File
                                        ? `${file.File.size / 1024} kb`
                                        : ""}
                                    </p>
                                    <a
                                      class="col-md-2 cursor-pointer"
                                      onClick={() =>
                                        this.props.removeFile(
                                          index,
                                          file.name || file.attachmentName
                                        )
                                      }
                                    >
                                      <i
                                        className="fa fa-times"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </div>
                                )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {
                    // currently for ILS they need this para at the bottom of premium section 
                  [ILS_CONSTS.ID].every((tt)=>tt!==this.props.customerId) && 
                  <div class="col-md-12 mt-2">
                    {FieldLabel("payingPremium", this.props.customerId)}
                  </div>
                  } 
                </div>
              </div>
              <div className="form-group ml-2">
                <div class="row">
                {this.props.customerId===ILS_CONSTS.ID &&
                    <h4 className="col-md-12 pl-0 mt-2">
                    <Text id="step2.Para3" />
                    </h4>
                  }
                  <fieldset class="radio radio-tab mt-3">
                    <legend>
                      <Text id="step2.paymentopt" />
                      {mandatoryFileds[this.props.customerId]?.enrollmentForm
                        .premiumType && (
                        <strong className="mandatory-field-bold">*</strong>
                      )}
                    </legend>
                    <div class="custom-control custom-radio custom-control-inline mt-1">
                      <input
                        type="radio"
                        name="premiumType"
                        id="month"
                        class="custom-control-input"
                        value="D"
                        checked={data.premiumType === "D"}
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="month"
                        class="radio-inline custom-control-label"
                      >
                        {FieldLabel("month", this.props.customerId)}
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline mt-1">
                      <input
                        type="radio"
                        name="premiumType"
                        id="autodeduct"
                        class="custom-control-input"
                        value="A"
                        checked={data.premiumType === "A"}
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="autodeduct"
                        class="radio-inline custom-control-label"
                      >
                        {FieldLabel("autodeduc", this.props.customerId)}
                      </label>
                    </div>
                    {(data.premiumType === "S" ||
                data.premiumType === "R" ||
                data.premiumType === "A") && this.props.customerId===ILS_CONSTS.ID? (
                  <div class="row pl-4">
                    <fieldset class="radio radio-tab mt-3">
                      <legend>
                        <Text id="step2.getmonthlyBenefits" />
                        <strong className="mandatory-field-bold">*</strong>
                      </legend>
                      <div class="custom-control custom-radio custom-control-inline mt-1">
                        <input
                          type="radio"
                          name="monthlybenefitsfrom"
                          id="S"
                          class="custom-control-input"
                          value="S"
                          checked={data.monthlybenefitsfrom === "S"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="S"
                          class="radio-inline custom-control-label"
                        >
                          <Text id="app.SS" />
                        </label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline mt-1">
                        <input
                          type="radio"
                          name="monthlybenefitsfrom"
                          id="R"
                          class="custom-control-input"
                          value="R"
                          checked={data.monthlybenefitsfrom === "R"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="R"
                          class="radio-inline custom-control-label"
                        >
                          {FieldLabel("RRB", this.props.customerId)}
                        </label>
                      </div>
                    </fieldset>
                  </div>
                ) : null}
                    {/* Premium type is having premiums of 
                          specific customers those will have extra premiums
                          */}
                    <PremiumType
                      customerId={this.props.customerId}
                      data={data}
                      handleChange={this.props.handleChange}
                      isPreview={false}
                    />
                  </fieldset>
                </div>
                {(data.premiumType === "S" ||
                data.premiumType === "R" ||
                data.premiumType === "A") && this.props.customerId!==ILS_CONSTS.ID? (
                  <div class="row">
                    <fieldset class="radio radio-tab mt-3">
                      <legend>
                        <Text id="step2.getmonthlyBenefits" />
                        <strong className="mandatory-field-bold">*</strong>
                      </legend>
                      <div class="custom-control custom-radio custom-control-inline mt-1">
                        <input
                          type="radio"
                          name="monthlybenefitsfrom"
                          id="S"
                          class="custom-control-input"
                          value="S"
                          checked={data.monthlybenefitsfrom === "S"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="S"
                          class="radio-inline custom-control-label"
                        >
                          <Text id="app.SS" />
                        </label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline mt-1">
                        <input
                          type="radio"
                          name="monthlybenefitsfrom"
                          id="R"
                          class="custom-control-input"
                          value="R"
                          checked={data.monthlybenefitsfrom === "R"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="R"
                          class="radio-inline custom-control-label"
                        >
                          {FieldLabel("RRB", this.props.customerId)}
                        </label>
                      </div>
                    </fieldset>
                  </div>
                ) : null}
                                {
                    // currently for ILS they need this para at the bottom of premium section 
                  [ILS_CONSTS.ID].every((tt)=>tt===this.props.customerId) && 
                  <div class="row mt-2">
                    {FieldLabel("payingPremium", this.props.customerId)}
                  </div>
                  }
              </div>
              {this.props.agentLogin === false && (
                <React.Fragment>
                  <TermsAndConditionsContainer />
                  <div class="checkbox checkbox-tab mt-3">
                    <div>
                      <label for="agreement">
                        <input
                          type="checkbox"
                          checked={
                            data.termsAndConditions === "Y" ? true : false
                          }
                          id="agreement"
                          name="termsAndConditions"
                          class={
                            data.termsAndConditions != "Y"
                              ? "checkbox-input-error"
                              : "checkbox-input"
                          }
                          onChange={this.props.handleChange}
                        />
                        &nbsp;
                        <strong>
                          <Text id="app.terms" />
                        </strong>
                      </label>
                    </div>
                  </div>
                  <br />
                  {this.props.customerId === VERDA_CONSTS.ID && (
                    <div class="checkbox checkbox-tab mt-1">
                      <div>
                        <label for="verbiage">
                          <input
                            type="checkbox"
                            checked={data.verbiage === "Y" ? true : false}
                            id="verbiage"
                            name="verbiage"
                            class={
                              // data.verbiage != "Y"
                              // ? "checkbox-input-error"
                              "checkbox-input"
                            }
                            onChange={this.props.handleChange}
                          />
                          &nbsp;
                          <strong>
                            <Text id="verda.verbiage" />
                            <strong className="mandatory-field-bold">*</strong>
                          </strong>
                        </label>
                      </div>
                    </div>
                  )}
                  <div class="form-group row">
                    <div class="col-md-4">
                      <label for="name" class="control-label">
                        <Text id="app.Name" />*
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={data.name}
                        maxLength="50"
                        onChange={this.props.handleChange}
                        class={
                          this.props.data.name === ""
                            ? "error-input"
                            : "form-control"
                        }
                        disabled={
                          this.props.customerId === VERDA_CONSTS.ID
                            ? data?.verbiage != "Y"
                            : false
                        }
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                      />
                    </div>
                    <div class="col-md-4">
                      <label for="name" class="control-label">
                        <Text id="app.DigitalSignature" />
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        disabled="true"
                        value={data.name}
                        onChange={this.props.handleChange}
                        class={"form-control cursor-not-allowed"}
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                      />
                    </div>
                    <div class="col-md-4">
                      <label for="todaysDate" class="control-label">
                        <Text id="app.TodayDate" />
                      </label>
                      <input
                        type="text"
                        id="todaysDate"
                        name="todayDate"
                        disabled="true"
                        value={
                          new Date()
                            .toLocaleString("en-US", {
                              timeZone:
                                Intl.DateTimeFormat().resolvedOptions()
                                  .timeZone,
                            })
                            .split(",")[0]
                        }
                        //onChange={this.props.handleChange}
                        class={"form-control cursor-not-allowed"}
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                      />
                    </div>
                    {this.props.agentLoggedIn === true ? (
                      <div class="mt-3 col-md-12">
                        <label class="control-label" for="fileUpload">
                          <Text id="step4Agent.sign" />
                        </label>
                        <div class="card">
                          <div className="card-header display-inline-flex">
                            <div>
                              <button
                                className="btn btn-success mr-2 mb-1"
                                onClick={this.save}
                              >
                                Save Signature
                              </button>
                              <button
                                className="btn btn-danger mb-1"
                                onClick={this.clear}
                              >
                                <i
                                  className="fa fa-times"
                                  aria-hidden="true"
                                ></i>
                                &nbsp;
                                <Text id="step4Agent.clear" />
                              </button>
                            </div>
                          </div>
                          <div class="panel">
                            <div class="card-body card-body-padding">
                              <SignaturePad
                                ref={(ref) => {
                                  this.sigPad = ref;
                                }}
                                canvasProps={{
                                  className: "sigCanvas",
                                  // height: 150,
                                  // width: 888,
                                  id: "sigCanvas",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div id="sigImg" class="col-md-2 mt-3 digital-img"></div>
                  </div>
                </React.Fragment>
              )}
              {this.props.preEnrollInfo?.appStatus != "READY" &&
                this.props.preEnrollInfo?.appStatus != "SUBMITTED" && (
                  <button
                    class="btn btn-saveNext save-next-color"
                    id="next3"
                    onClick={this.props.redirect}
                    disabled={
                      this.props?.Submitted ||
                      this.props.preEnrollInfo?.appStatus === "READY" ||
                      this.props.preEnrollInfo?.appStatus === "SUBMITTED"
                    }
                  >
                    <Text id="app.Save_Next" />
                  </button>
                )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  const physicians =
    state.webApp && state.webApp.physicians
      ? state.webApp.physicians.map((_data) => ({
          ..._data,
          label: _data.physicianName,
        }))
      : [];
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    permanentAddrStreet: state.webApp.permanentAddrStreet,
    permanentCity: state.webApp.permanentCity,
    permanentZip: state.webApp.permanentZip,
    zipCode: state.webApp.zip,
    physicians, //: state.webApp.physicians,
    physiciansData: state.webApp.physiciansData,
    pcpSelected: state.webApp.selectedVo,
    pendingApplFlag: state.webApp.pendingApplFlag,
    deeplink: state.login.deeplink,
    dpzipCode: state.login.dpzipCode,
    preEnrollInfo: state.webApp.preEnrollInfo,
    authenticatedData: state.login.authenticatedData,
    Submitted: state.webApp.Submitted,
    appNum: state.webApp.appNum,
    guestbeneagentAppNum: state.webApp.guestbeneagentAppNum,
    count: state.webApp.count,
    agentLoggedIn: state.login.agentLoggedIn,
    stateId: state.webApp.stateId,
    planType: state.webApp.planType,
    product: state.webApp?.product ? state.webApp?.product : "",
    customerId: state.login.customerId,
    ltcList: state.login.ltcList,
    pcpSubscription: state.login.pcpSubscription,
    productId: state.login.productId,
    language: state.webApp.language,
  };
};
const mapDispatchToProps = {
  getPcpList,
  setStateParams,
  deleteFile,
  downloadFormsPdf,
  fetchFileTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(Step3);
